var arabam;
(function (arabam) {
    var FavoriteService = /** @class */ (function () {
        function FavoriteService($q, HttpHelperService, $window, $rootScope) {
            this.$q = $q;
            this.HttpHelperService = HttpHelperService;
            this.$window = $window;
            this.$rootScope = $rootScope;
            this.favoriteList = {
                addDate: undefined,
                list: []
            };
        }
        FavoriteService.prototype.init = function () {
            /**
             * algo
             *
             * localstorage bak, eger favori listesi varsa cek
             * listenin tarihi 24 saatten eski ise yenile
             * degilse degiskene ata
             */
            var self = this;
            if (this.isBrowserCompatible()) {
                this.readLocalStorage();
                /** listenin tarihi 24 saatten eskiyse yenile */
                if (this.favoriteList && (this.favoriteList.addDate && (this.favoriteList.addDate + 86400000 < Date.now()) || !this.favoriteList.addDate)) {
                    this.getFavoritesFromService().then(function (list) {
                        self.favoriteList.list = list;
                        self.writeLocalStorage();
                    });
                }
                return true;
            }
            else {
                return false;
            }
        };
        FavoriteService.prototype.toggleFavorite = function (advertId) {
            var self = this;
            if (self.checkIfFavorited(advertId)) {
                return self.removeFromFavorite(advertId);
            }
            else {
                return self.addToFavorite(advertId);
            }
        };
        FavoriteService.prototype.addToFavorite = function (advertId, listId) {
            var d = this.$q.defer();
            var self = this;
            var request = {
                AdvertId: advertId
            };
            this.HttpHelperService.httpPost("/ilan/favori", request, function (res) {
                self.favoriteList.list.push(advertId);
                self.writeLocalStorage();
                self.$rootScope.UnreadFavCount = +(self.$rootScope.UnreadFavCount) + 1;
                d.resolve(res.Success);
            }, function (error) {
                d.reject(error);
            }, { isNotLoading: true });
            return d.promise;
        };
        FavoriteService.prototype.removeFromFavorite = function (advertId) {
            var d = this.$q.defer();
            var self = this;
            this.HttpHelperService.httpDelete("/ilan/favorisil?Id=" + advertId, function (res) {
                self.favoriteList.list.splice(self.favoriteList.list.indexOf(advertId), 1);
                self.writeLocalStorage();
                self.$rootScope.UnreadFavCount = +(self.$rootScope.UnreadFavCount) - 1;
                d.resolve(res.Success);
            }, function (error) {
                d.reject(error);
            }, { isNotLoading: true });
            return d.promise;
        };
        FavoriteService.prototype.getFavoritesFromService = function () {
            var d = this.$q.defer();
            this.HttpHelperService.httpGetWithPromise("/ilan/favoriilanlar", { isNotLoading: true }).then(function (result) {
                d.resolve(result.Data);
            }).catch(function (error) {
                d.reject(error);
            });
            return d.promise;
        };
        FavoriteService.prototype.checkIfFavorited = function (advertId) {
            if (this.favoriteList && this.favoriteList.list) {
                return this.favoriteList.list.indexOf(advertId) > -1 ? true : false;
            }
            else {
                return false;
            }
        };
        /**
         * listeyi local storage'a yaz
         */
        FavoriteService.prototype.writeLocalStorage = function () {
            var self = this;
            try {
                this.favoriteList.addDate = Date.now();
                localStorage.setItem("favoriteList", JSON.stringify(this.favoriteList));
            }
            catch (e) {
                return false;
            }
            return true;
        };
        /**
         * local storage'dan listeyi oku
         */
        FavoriteService.prototype.readLocalStorage = function () {
            var self = this;
            try {
                var temp = localStorage.getItem("favoriteList");
                if (temp) {
                    self.favoriteList = JSON.parse(temp);
                }
            }
            catch (e) {
                return false;
            }
            return true;
        };
        /**
         * storage tipi mevcut mu
         * @param type
         */
        FavoriteService.prototype.storageAvailable = function (type) {
            try {
                var storage = this.$window[type];
                var x = '__storage_test__';
                storage.setItem(x, x);
                storage.removeItem(x);
                return true;
            }
            catch (e) {
                return false;
            }
        };
        FavoriteService.prototype.isBrowserCompatible = function () {
            var self = this;
            var result = false;
            result = self.storageAvailable('localStorage');
            if (!result) {
                result = self.storageAvailable('sessionStorage');
            }
            return result;
        };
        FavoriteService.$inject = ["$q", "HttpHelperService", "$window", "$rootScope"];
        return FavoriteService;
    }());
    arabam.FavoriteService = FavoriteService;
    angular.module("arabam").service("FavoriteService", FavoriteService);
})(arabam || (arabam = {}));
